import "./index.less";
import HyperLinkText from "./hyper-link-text";
function CardRelationMatters(props) {
  const { msg } = props;

  const items = msg.urlList.map(
    (item, index) => {
      const Component = HyperLinkText;
      return (
        <li className="attachment_item" key={index}>
          <Component file={item} />
        </li>
      );
    }
  );

  return (
    <div className="card_hyper-links text-links">
      <div className="msg-line">
        <h4 className="inner-card__title">相关链接</h4>
        <ul>{items}</ul>
      </div>
    </div>
  );
}

export default CardRelationMatters;
